/**
 * @file 全局逻辑
 */
import { initReporter } from "@huyafed/gametool-report";
import { TOOL_ID, TOOL_TYPE } from "@/config/env";
import { tafFetch } from "@/api/_tafFetch";

document.title = import.meta.env.VITE_TITLE as string;

// 上报初始化
initReporter(TOOL_ID, TOOL_TYPE, tafFetch).catch((err) =>
  console.error("initReporter failed:", err),
);
